<div class="toast-container">
  @for (toast of toastService.toasts; track toast) {
  <ngb-toast [class]="toast.classname" [autohide]="true" [delay]="toast.delay || 5000"
    (hidden)="toastService.remove(toast)" class="custom-toast">

    <div class="toast-content">

      <div class="toast-icon">
        @if (toast.classname == 'bg-danger text-light') {
        <fa-icon [icon]="faCircleExclamation" size="xl"></fa-icon>
        }

        @if (toast.classname == 'bg-success text-light') {
        <fa-icon [icon]="faCircleCheck" size="xl"></fa-icon>
        }

        @if (toast.classname == 'bg-warning text-dark') {
        <fa-icon [icon]="faTriangleExclamation" size="xl"></fa-icon>
        }
      </div>

      <div class="toast-message">
        @if (isTemplate(toast)) {
        <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
        } @else {
        {{ toast.textOrTpl }}
        }
      </div>

    </div>

  </ngb-toast>
  }
</div>